module.exports = __webpack_public_path__ + "static/media/Dodrio_gaussian2.31a55d41.png";